import { Options } from 'vue-class-component';
import DeviceSettingsComponent from '../DeviceSettingsComponent';
import { LightsOnOffMode } from '@/../client-generator/generated-clients/device-settings';

@Options({
  name: 'LightsCommandSettings',
})
export default class LightsCommandSettings extends DeviceSettingsComponent {
  LightsOnOffMode = LightsOnOffMode;

  get settings() {
    return this.defaultSettings.lightsCommandSettings;
  }
}
